// extracted by mini-css-extract-plugin
export default {"icon":"Step_icon__s1kmX","content":"Step_content__0E6Ga","step":"Step_step__5pE-4"};